import { call, put } from "typed-redux-saga";
import { RecaptchaCheckResponse } from "../../core/api/requests/recaptcha/check/types";
import { TwilioCheckResponse } from "../../core/api/requests/twilio/check/types";
import { TwilioSendResponse } from "../../core/api/requests/twilio/send/types";
import { recaptchaCheckApi } from "../../core/http/httpClient";
import { twilioCheckApi, twilioSendApi } from "../../core/http/twilioClient";
import { ApiResponse } from "../../core/types";
import { takeEveryFsa } from "../operations";
import { externalActions } from "./actions";

export function* externalSaga() {
  yield takeEveryFsa(
    externalActions.checkRecaptcha.started,
    function* (action) {
      const { onComplete, onError, onSuccess, ...body } = action.payload;
      const { response, error }: ApiResponse<RecaptchaCheckResponse> =
        yield call(() => {
          return recaptchaCheckApi
            .call(body)
            .then((response) => ({ response }))
            .catch((error) => ({ error }));
        });

      onComplete?.();

      if (!response || error) return onError?.(error);

      const isSuccess = response.data.status === "success";

      if (!isSuccess) return onError?.(error);

      yield* put(
        externalActions.checkRecaptcha.done({
          params: action.payload,
          result: isSuccess,
        }),
      );
      onSuccess?.(isSuccess);
    },
  );

  yield takeEveryFsa(
    externalActions.checkTwilioCode.started,
    function* (action) {
      const { onComplete, onError, onSuccess, ...body } = action.payload;
      const { response, error }: ApiResponse<TwilioCheckResponse> = yield call(
        () => {
          return twilioCheckApi
            .call(body)
            .then((response) => ({ response }))
            .catch((error) => ({ error }));
        },
      );

      onComplete?.();

      if (!response || error) return onError?.(error);

      const isSuccess = response.data.valid;

      if (!isSuccess) return onError?.(error);

      yield* put(
        externalActions.checkTwilioCode.done({
          params: action.payload,
          result: isSuccess,
        }),
      );
      onSuccess?.(isSuccess);
    },
  );

  yield takeEveryFsa(
    externalActions.sendTwilioCode.started,
    function* (action) {
      const { onComplete, onError, onSuccess, ...body } = action.payload;
      const { response, error }: ApiResponse<TwilioSendResponse> = yield call(
        () => {
          return twilioSendApi
            .call(body)
            .then((response) => ({ response }))
            .catch((error) => ({ error }));
        },
      );

      onComplete?.();

      if (!response || error) return onError?.(error);

      yield* put(
        externalActions.sendTwilioCode.done({
          params: action.payload,
          result: response.data,
        }),
      );
      onSuccess?.(response.data);
    },
  );
}
